module.exports = __webpack_public_path__ + "static/media/media1.a62fd173.jpg";